import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // NAVBAR
      navbar: {
        embassy: "L'AMBASSADE",
        beninInChina: "Le Bénin en Chine",
        diplomaticTeam: "L'équipe diplomatique",
        cooperation: "Coopération",
        honoraryConsulate: "Consulats honoraires",
        news: "Actualités",
        services: "Services",
        opportunities: "Opportunités/affaires",
        whyInvest: "Pourquoi investir au bénin",
        governmentProgram: "Programme d'action du gouvernement",
        visitBenin: "Visiter le Bénin",
        visitChina: "Voyager en Chine",
        appointment: "Contactez-nous",
         worldofsplendor: "Un monde de splendeur",
  significantevent: "Nos évènements marquants",
  eventsInChina: "évènements En Chine"
      },
      // SEARCH MODAL
      search: {
        title: "Faire une recherche",
        placeholder: "SAISISSEZ VOTRE RECHERCHE ICI"
      },
      // APPOINTMENT MODAL
      appointment: {
        title: "Prendre Rendez-Vous",
        lastName: "Nom",
        firstName: "Prénom",
        email: "Email",
        message: "Message...",
        submit: "ENVOYER LA DEMANDE"
      },

      Faq: {
        title: "FOIRE AUX QUESTIONS",
        bottomMore: "Voir plus",
        bottomLess: "Voir moins",
      },

      lienUtile: {
        officialWebsite: "Site internet officiel",
        title: "LIENS UTILES",
        otherLinks: "Autres liens utiles"
      },

      home: {
        investmentTitle: "Investissement",
        tourismTitle: "Tourisme",
        latestNewsTitle: "Dernières actualités"
      },

      latestNews: {
        empty: "Aucune actualité disponible"
      },

      Menu: {
        title1: "L'AMBASSADE",
        descrip1: "Univers diplomatique",
        submenu1: "Toute l'actualité",
        submenu2: "Représentations diplomatiques",
        title2: "BÉNINOIS À L'ÉTRANGER",
        descrip2: "Restez concentré",
        submenu3: "ACCORDS SUPPRESSION DE VISA",
        submenu4: "DEMANDEZ UN RENDEZ-VOUS",
        title3: "VOYAGEUR",
        descrip3: "Kit du voyageur",
        submenu5: "SERVICES CONSULAIRES",
        submenu6: "EVISA EN LIGNE",
      },

      footer: {
        logoAlt: "Ambassade du Bénin",
        embassyTitle: "L'AMBASSADE",
        contactUs: "CONTACTEZ-NOUS",
        makeAppointment: "PRENDRE RENDEZ-VOUS",
        legal: "Mentions légales et gestions des cookies",
        nav: {
          embassy: "L'AMBASSADE",
          news: "ACTUALITÉS",
          services: "SERVICES",
          opportunities: "OPPORTUNITÉS/AFFAIRES",
          visitBenin: "VISITER LE BÉNIN",
          travelChina: "VOYAGER EN CHINE" // Changé de travelQatar à travelChina
        }
      },

      ambassade: {
        formerAmbassadors: "ANCIENS AMBASSADEURS",
        formerAmbassadorsTitle: "Anciens ambassadeurs en Chine", // Changé de Doha à Chine
        beninChinaAlt: "Ambassade du Bénin en Chine", // Changé de beninQatarAlt à beninChinaAlt
        leadershipAlt: "Leadership diplomatique"
      },
      common: {
        infoUnavailable: "Information indisponible",
        close: "Fermer",
        error: "Erreur de chargement des données",
        loading: "chargement",
      },

      ambassador: {
        title: "L'ambassadeur",
        messageUnavailable: "Message non disponible"
      },

      equipeDiplomatique: {
        title: "équipe diplomatique"
      },

      Consul: {
        descrip: "Rechercher un consulat",
      },

      menuSection: {
        honoraryConsulates: "CONSULATS HONORAIRES",
        cooperation: "Coopération",
        mapAlt: "Carte"
      },

      articles: {
        allArticles: "TOUS LES ARTICLES",
        noArticles: "Aucun article disponible dans cette catégorie",
        articlesLoaded: "articles chargés au total",
        availableCategories: "Catégories disponibles",
        title: "Actualités"
      },

      invest: {
        keyIndicators: "Indicateurs clés",
      },
      beninInfo: {
        symbols: "SYMBOLES",
        symbolsValue: "Drapeau, hymne et emblèmes nationaux",
        languagesTitle: "Langues du Bénin",
        geographyTitle: "Géographie du Bénin"
      },

      visiterChine: {
        welcomeTitle: "BIENVENUE EN CHINE", // Changé de "AU CHINA" à "EN CHINE"
        galery: "PHOTOS & VIDÉOS", 
      },

      team:{
        noMembers: "Aucun membre"
      },

      footer: {
        logoAlt: "Ambassade du Bénin",
        embassyTitle: "L'AMBASSADE",
        contactUs: "CONTACTEZ-NOUS",
        makeAppointment: "PRENDRE RENDEZ-VOUS",
        legal: "Mentions légales et gestions des cookies",
        nav: {
          embassy: "L'AMBASSADE",
          news: "ACTUALITÉS",
          services: "SERVICES",
          opportunities: "OPPORTUNITÉS/AFFAIRES",
          visitBenin: "VISITER LE BÉNIN",
          travelQatar: "VOYAGER AU QATAR"
        }
      },
      common: {
        infoUnavailable: "Information indisponible",
        close: "Fermer",
        error: "Erreur de chargement des données",
        loading: "chargement",
      },

      ambassador: {
        title: "L'ambassadeur",
        messageUnavailable: "Message non disponible"
      },

      equipeDiplomatique: {
        title: "équipe diplomatique"
      },

      Consul: {
        descrip: "Rechercher un consulat",
      },

      menuSection: {
        honoraryConsulates: "CONSULATS HONORAIRES",
        cooperation: "Coopération",
        mapAlt: "Carte"
      },

      articles: {
        allArticles: "TOUS LES ARTICLES",
        noArticles: "Aucun article disponible dans cette catégorie",
        articlesLoaded: "articles chargés au total",
        availableCategories: "Catégories disponibles",
        title: "Actualités"
      },

      invest: {
        keyIndicators: "Indicateurs clés",
      },
      beninInfo: {
        symbols: "SYMBOLES",
        symbolsValue: "Drapeau, hymne et emblèmes nationaux",
        languagesTitle: "Langues du Bénin",
        geographyTitle: "Géographie du Bénin"
      },

      
      articleDetail: {
        loading: "Chargement de l'article...",
        notFound: "Article non trouvé",
        notFoundMessage: "L'article que vous recherchez n'existe pas ou n'est plus disponible.",
        backToArticles: "← Retour aux articles",
        publishedOn: "Publié le",
        externalLinkMessage: "Cet article contient un lien externe vers :",
        readOnLinkedIn: "📖 Lire l'article complet sur LinkedIn",
        noContent: "Le contenu complet de cet article n'est pas encore disponible.",
        description: "Description",
        recentArticles: "Articles récents",
        readArticle: "LIRE L'ARTICLE",
        noRecentArticles: "Aucun autre article récent"
      },

      investmentData: {
        title: "Données d'investissements"
      },

      breadcrumb: {
        home: "Accueil",
        news: "Actualités"
      },

      pagination: {
        previous: "Précédent",
        next: "Suivant"
      },

      team: {
        noMembers: "Aucun membre",
        bibliography: "Bibliographie",
        noBibliography: "Aucune bibliographie disponible"
      },

    }
  },
  en: {
    translation: {

      pagination: {
        previous: "Previous",
        next: "Next"
      },

      // NAVBAR
      navbar: {
        embassy: "THE EMBASSY",
        beninInChina: "Benin in China",
        diplomaticTeam: "Diplomatic team",
        cooperation: "Cooperation",
        honoraryConsulate: "Honorary consulate",
        news: "News",
        services: "Services",
        opportunities: "Opportunities/Business",
        whyInvest: "Why invest in Benin",
        governmentProgram: "Government action program",
        visitBenin: "Visit Benin",
        visitChina: "Traveling in China",
        appointment: "Make an Appointment",
        worldofsplendor: "A world of splendor",
  significantevent: "Our significant events",
  eventsInChina: "Events in China"
      },
      // SEARCH MODAL
      search: {
        title: "Search",
        placeholder: "ENTER YOUR SEARCH HERE"
      },
      // APPOINTMENT MODAL
      appointment: {
        title: "Make an Appointment",
        lastName: "Last Name",
        firstName: "First Name",
        email: "Email",
        message: "Message...",
        submit: "SEND REQUEST"
      },

      Faq: {
        title: "FREQUENTLY ASKED QUESTIONS",
        bottomMore: "See more",
        bottomLess: "See less",
      },

      lienUtile: {
        officialWebsite: "Official website",
        title: "USEFUL LINKS",
        otherLinks: "Other useful links"
      },

      home: {
        investmentTitle: "Investment",
        tourismTitle: "Tourism",
        latestNewsTitle: "Latest news"
      },

      latestNews: {
        empty: "No news available"
      },

      Menu: {
        title1: "THE EMBASSY",
        descrip1: "Diplomatic world",
        submenu1: "All the latest news",
        submenu2: "Diplomatic representations",
        title2: "BENINESE ABROAD",
        descrip2: "Stay focused",
        submenu3: "CONSULAR SERVICES",
        submenu4: "REQUEST AN APPOINTMENT",
        title3: "TRAVELER",
        descrip3: "Traveler's kit",
        submenu5: "VISA WAIVER AGREEMENTS",
        submenu6: "EVISA ONLINE",
      },

      footer: {
        logoAlt: "Embassy of Benin",
        embassyTitle: "THE EMBASSY",
        contactUs: "CONTACT US",
        makeAppointment: "MAKE AN APPOINTMENT",
        legal: "Legal notices and cookie management",
        nav: {
          embassy: "THE EMBASSY",
          news: "NEWS",
          services: "SERVICES",
          opportunities: "OPPORTUNITIES/BUSINESS",
          visitBenin: "VISIT BENIN",
          travelChina: "TRAVEL TO CHINA" // Changé de travelQatar à travelChina
        }
      },

      ambassade: {
        formerAmbassadors: "FORMER AMBASSADORS",
        formerAmbassadorsTitle: "Former ambassadors to China", // Changé de Doha à China
        beninChinaAlt: "Embassy of Benin in China", // Changé de beninQatarAlt à beninChinaAlt
        leadershipAlt: "Diplomatic leadership"
      },
      common: {
        infoUnavailable: "Information unavailable",
        close: "Close",
        error: "Error loading data",
        loading: "loading",
      },

      ambassador: {
        title: "The Ambassador",
        messageUnavailable: "Message not available"
      },

      equipeDiplomatique: {
        title: "diplomatic team"
      },

      Consul: {
        descrip: "Search for a consulate",
      },
      menuSection: {
        honoraryConsulates: "HONORARY CONSULATES",
        cooperation: "Cooperation",
        mapAlt: "Map"
      },

      articles: {
        allArticles: "ALL ARTICLES",
        noArticles: "No articles available in this category",
        articlesLoaded: "articles loaded",
        availableCategories: "Available categories",
        title: "NEWS"
      },

      invest: {
        keyIndicators: "Key indicators",
      },

      investmentData: {
        title: "Investment Data"
      },

      beninInfo: {
        symbols: "SYMBOLS",
        symbolsValue: "Flag, anthem and national emblems",
        languagesTitle: "Languages of Benin",
        geographyTitle: "Geography of Benin"
      },

      visiterChine: {
        welcomeTitle: "WELCOME TO CHINA",
        galery: "PHOTOS & VIDEOS",
      },

      team:{
        noMembers: "No members"
      },

      articleDetail: {
        loading: "Loading article...",
        notFound: "Article not found",
        notFoundMessage: "The article you are looking for does not exist or is no longer available.",
        backToArticles: "← Back to articles",
        publishedOn: "Published on",
        externalLinkMessage: "This article contains an external link to:",
        readOnLinkedIn: "📖 Read full article on LinkedIn",
        noContent: "The full content of this article is not yet available.",
        description: "Description",
        recentArticles: "Recent articles",
        readArticle: "READ ARTICLE",
        noRecentArticles: "No other recent articles"
      },

      breadcrumb: {
        home: "Home",
        news: "News"
      },
      team: {
        noMembers: "No members",
        bibliography: "Bibliography",
        noBibliography: "No bibliography available"
      },
    }
  },
  zh: {
    translation: {
      // NAVBAR - 导航栏
      navbar: {
        embassy: "大使馆",
        beninInChina: "贝宁在中国",
        diplomaticTeam: "外交团队",
        cooperation: "合作",
        honoraryConsulate: "名誉领事馆",
        news: "新闻",
        services: "服务",
        opportunities: "商机/机会",
        whyInvest: "为什么在贝宁投资",
        governmentProgram: "政府行动计划",
        visitBenin: "访问贝宁",
        visitChina: "访问中国",
        appointment: "预约"
      },
      // SEARCH MODAL - 搜索弹窗
      search: {
        title: "搜索",
        placeholder: "在此输入您的搜索内容"
      },
      // APPOINTMENT MODAL - 预约弹窗
      appointment: {
        title: "预约",
        lastName: "姓",
        firstName: "名",
        email: "电子邮件",
        message: "留言...",
        submit: "发送请求"
      },
      
      // Ajout des clés manquantes pour le chinois
      footer: {
        logoAlt: "贝宁大使馆",
        embassyTitle: "大使馆",
        contactUs: "联系我们",
        makeAppointment: "预约",
        legal: "法律声明和Cookie管理",
        nav: {
          embassy: "大使馆",
          news: "新闻",
          services: "服务",
          opportunities: "商机/商业",
          visitBenin: "访问贝宁",
          travelChina: "访问中国"
        }
      },
      
      ambassade: {
        formerAmbassadors: "前任大使",
        formerAmbassadorsTitle: "驻中国前任大使",
        beninChinaAlt: "贝宁驻中国大使馆",
        leadershipAlt: "外交领导"
      },
      
      common: {
        infoUnavailable: "信息不可用",
        close: "关闭",
        error: "加载数据错误",
        loading: "加载中"
      },
      
      visiterChine: {
        welcomeTitle: "欢迎来到中国",
        galery: "图片与视频",
      },

      team: {
        noMembers: "暂无成员",
        bibliography: "个人简介",
        noBibliography: "暂无简介信息"
      },

      
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "fr",
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;